"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jobAttachmentListResponseSchema = exports.initializeJobAttachmentResponseSchema = exports.jobAttachmentUploadTargetSchema = exports.jobAttachmentSchema = exports.completeJobAttachmentRequestSchema = exports.initializeJobAttachmentRequestSchema = exports.jobAttachmentChecksumSchema = exports.jobAttachmentLifecycleSchema = exports.jobAttachmentUploadStatusSchema = exports.jobAttachmentKindSchema = exports.jobAttachmentIdSchema = void 0;
const zod_1 = require("zod");
exports.jobAttachmentIdSchema = zod_1.z.string().uuid();
exports.jobAttachmentKindSchema = zod_1.z.enum(["FILE", "PHOTO"]);
exports.jobAttachmentUploadStatusSchema = zod_1.z.enum([
    "PENDING",
    "READY",
    "FAILED",
]);
exports.jobAttachmentLifecycleSchema = zod_1.z.enum(["ACTIVE", "ARCHIVED"]);
exports.jobAttachmentChecksumSchema = zod_1.z
    .string()
    .regex(/^[0-9a-f]{64}$/, "Checksum must be a lowercase SHA-256 digest.");
exports.initializeJobAttachmentRequestSchema = zod_1.z.object({
    originalFileName: zod_1.z.string().trim().min(1).max(255),
    mimeType: zod_1.z.string().trim().min(3).max(120),
    fileSizeBytes: zod_1.z
        .number()
        .int()
        .positive()
        .max(100 * 1024 * 1024),
    checksumSha256: exports.jobAttachmentChecksumSchema,
    kind: exports.jobAttachmentKindSchema,
});
exports.completeJobAttachmentRequestSchema = zod_1.z.object({
    checksumSha256: exports.jobAttachmentChecksumSchema,
    fileSizeBytes: zod_1.z
        .number()
        .int()
        .positive()
        .max(100 * 1024 * 1024),
});
exports.jobAttachmentSchema = zod_1.z.object({
    id: exports.jobAttachmentIdSchema,
    jobId: zod_1.z.string().uuid(),
    originalFileName: zod_1.z.string(),
    mimeType: zod_1.z.string(),
    fileSizeBytes: zod_1.z.number().int().positive(),
    checksumSha256: exports.jobAttachmentChecksumSchema,
    kind: exports.jobAttachmentKindSchema,
    uploadStatus: exports.jobAttachmentUploadStatusSchema,
    lifecycle: exports.jobAttachmentLifecycleSchema,
    failureReason: zod_1.z.string().nullable(),
    uploadedByMembershipId: zod_1.z.string().uuid(),
    downloadPath: zod_1.z.string().min(1).nullable(),
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
    readyAt: zod_1.z.string().datetime().nullable(),
    archivedAt: zod_1.z.string().datetime().nullable(),
});
exports.jobAttachmentUploadTargetSchema = zod_1.z.object({
    method: zod_1.z.literal("PUT"),
    url: zod_1.z.string().min(1),
    headers: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    expiresAt: zod_1.z.string().datetime(),
});
exports.initializeJobAttachmentResponseSchema = zod_1.z.object({
    attachment: exports.jobAttachmentSchema,
    upload: exports.jobAttachmentUploadTargetSchema,
});
exports.jobAttachmentListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.jobAttachmentSchema),
});
//# sourceMappingURL=job-attachment.js.map